import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkItemIntegration } from 'common/store/genesys-cloud/work-item-integrations/models/work-item-integrations.model';

@Component({
  selector: 'app-genesys-widget-header-tools',
  templateUrl: './genesys-widget-header-tools.component.html',
  styleUrls: ['./genesys-widget-header-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysWidgetHeaderToolsComponent {
  @Input()
  isExpandedMode: boolean;
  @Input()
  integrations: WorkItemIntegration[];
  @Input()
  openIntegrationPanels: WorkItemIntegration[];
  @Input()
  isCobrowseAllowed: boolean;
  @Input()
  isCobrowseActive: boolean;
  @Output()
  readonly minimize = new EventEmitter<void>();
  @Output()
  readonly toggleExpanded = new EventEmitter<void>();
  @Output()
  readonly toggleIntegration = new EventEmitter<string>();
  @Output()
  readonly toggleCobrowse = new EventEmitter<string>();

  getFirstLetter(str: string = ''): string {
    return str.trim().charAt(0).toLocaleUpperCase();
  }
}
